import './config/initializeSentry';
import {createRoot} from 'react-dom/client';
import {CacheProvider} from '@emotion/react';
import initializeDatadogRum from 'services/initializeDatadogRum';
import createCache from '@emotion/cache';
import App from './App';

initializeDatadogRum();

const cache = createCache({key: 'ez'});
cache.compat = true;

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(
  <CacheProvider value={cache}>
    <App />
  </CacheProvider>
);
